<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModalInserirAlerta()">
            <span> <i class="fa fa-plus mr-2"></i>Criar Alerta</span>
        </b-button>
        <b-modal id="modalInserirAlerta" v-model="mostrarModalInserirAlerta">
            <div slot="modal-title">
                Alertas -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col>
                    <b-form-group>
                        <label>Vigência do Contrato: 
                            <strong> 
                                {{ $moment(dataInicioVigencia).format('DD/MM/YYYY') }} 
                                a 
                                {{ $moment(dataFimVigencia).format('DD/MM/YYYY') }}
                            </strong>
                        </label>
                    </b-form-group> 
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group
                        :state="!camposInvalidos.dataAlerta"
                        invalid-feedback="Data do Alerta é obrigatória"
                    >
                        <label class="required">Data do Alerta</label>
                        <date-picker
                            v-model="dataAlerta"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group> 
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="!camposInvalidos.motivo"
                        invalid-feedback="Motivo é obrigatório"
                    >
                        <label class="required">Motivo</label>
                        <b-form-textarea
                            v-model="motivo"
                            :rows="2"
                            :maxlength="50"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalInserirAlerta()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    @click.stop="confirmarInserirAlerta()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>
  
  <script>
import AlertasServicos from './AlertasServicos'

export default {
    props: {
        idContrato: {
            type: String
        },
        dataInicioVigencia: {
            type: String
        },
        dataFimVigencia: {
            type: String
        }
    },
    data() {
        return {
            mostrarModalInserirAlerta: false,
            operacao: 'INSERIR',
            dataAlerta: '',
            motivo: '',
            erros: [],
            camposInvalidos: {
                dataAlerta: false,
                motivo: false,
            },
        }
    },
    methods: {
        confirmarInserirAlertaModal() {
            this.$swal({
                title: 'Confirmação',
                html: `Confirma a inserção do alerta na data ${this.dataAlerta}?`,
                icon: 'warning', 
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('inserirAlerta')
                    this.salvarAlerta()
                }
            })
        },

        salvarAlerta() {
            let alertasDto = {
                dataAlerta: this.dataAlerta
                    ? this.$moment(this.dataAlerta, 'DD/MM/YYYY').toISOString()
                    : '',
                motivo: this.motivo,
                idContrato: this.idContrato
            }
            this.$store.dispatch('addRequest')
            AlertasServicos.inserirAlerta(alertasDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAlertasPorContrato() {
            this.$emit('obterAlertasVigencia')
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAlertasAtualizados')
            this.fecharModalInserirAlerta()
        },

        abrirModalInserirAlerta() {
            this.mostrarModalInserirAlerta = true;
            this.resetarErros();
            this.resetarCampos();
        },

        fecharModalInserirAlerta() {
            this.mostrarModalInserirAlerta = false;
            this.resetarErros();
        },

        resetarErros() {
            this.erros = [];
            this.camposInvalidos = {
                dataAlerta: false,
                motivo: false,
            };
        },

        resetarCampos() {
            this.dataAlerta = '';
            this.motivo = '';
        },

        validarCampos() {
            let valido = true;

            if (!this.dataAlerta) {
                this.camposInvalidos.dataAlerta = true;
                valido = false;
            } else {
                this.camposInvalidos.dataAlerta = false;
            }

            if (!this.motivo || this.motivo.trim() === "") {
                this.camposInvalidos.motivo = true;
                valido = false;
            } else {
                this.camposInvalidos.motivo = false;
            }

            return valido;
        },

        confirmarInserirAlerta() {
            if (this.validarCampos()) {
                this.confirmarInserirAlertaModal();
            } else {
                this.erros = ["Preencha todos os campos obrigatórios."];
            }
        },
    }
}
</script>
  